import EntityFormField from 'vue-forms/components/EntityFormField';

export default {
  mixins: [ EntityFormField ],

  props: {
    component: {
      default: 'analysis-input-field'
    },
  }
};
